/**
 * *************************
 * Project Routes Components *
 * *************************
 */
const Projects = () => import('@/components/Discovery/Projects');
const ProjectArchivedItemsListing = () =>
  import('@/components/Discovery/Widgets/ProjectArchivedItemsListing');
const ProjectArchivedVaultItemListing = () =>
  import('@/components/Discovery/Widgets/ProjectArchivedVaultItemListing');

/**
 * *************************
 * Email Routes Components *
 * *************************
 */
const EmailSearch = () => import('@/components/Organisations/EmailSearch');
const ArchiveDetail = () => import('@/components/Discovery/ArchiveDetail');

/**
 * *************************
 * Vault Routes Components *
 * *************************
 */
const VaultArchive = () => import('@/components/ArchiveSearch/VaultArchive');
const VaultArchiveDetail = () =>
  import('@/components/ArchiveSearch/VaultArchiveDetail');
const ArchiveVaultDetail = () =>
  import('@/components/Discovery/ArchiveVaultDetail');

export default {
  path: 'projects/:projectId',
  component: Projects,
  redirect: 'projects/:projectId/p1',
  children: [
    {
      path: 'p:pageNumber',
      component: EmailSearch,
      meta: {
        tabType: 0,
        tabName: 'EMAIL ARCHIVES',
        permission: [
          {
            action: 'view',
            entity: 'discovery_project'
          }
        ]
      },
      props: { type: 'project-search' }
    },
    {
      path: 'vault/p:pageNumber',
      component: VaultArchive,
      props: {
        defaultExpanded: true,
        from: 'DISCOVERY',
        type: 'discovery'
      },
      meta: {
        tabType: 1,
        tabName: 'VAULT ARCHIVES',
        permission: [
          {
            action: 'view',
            entity: 'discovery_project'
          }
        ]
      }
    },
    {
      path: 'vault/search/:archiveId/:version?',
      component: VaultArchiveDetail,
      meta: {
        permission: [
          {
            action: 'search',
            entity: 'organisation_toolbox_archives'
          },
          {
            action: 'view',
            entity: 'discovery_project'
          }
        ]
      }
    },

    {
      path: 'archive/:archiveId',
      component: ArchiveDetail,
      children: [
        { path: 'attachment/:attachmentId', component: ArchiveDetail }
      ],
      meta: {
        permission: [
          {
            action: 'view',
            entity: 'discovery_project'
          }
        ]
      }
    },

    {
      path: 'archive/vault/connector/:connectorType/:archiveId',
      component: ArchiveVaultDetail,
      meta: {
        permission: [
          {
            action: 'view',
            entity: 'discovery_project'
          }
        ]
      }
    },
    {
      path: 'archives',
      redirect: 'archives/p1'
    },
    {
      path: 'archives/p:pageNumber?',
      component: ProjectArchivedItemsListing,
      meta: {
        tabType: 0,
        tabName: 'SAVED EMAIL ARCHIVES',
        permission: [
          {
            action: 'view',
            entity: 'discovery_project'
          }
        ]
      }
    },
    {
      path: 'archives/vault/p:pageNumber?',
      component: ProjectArchivedVaultItemListing,
      meta: {
        tabType: 1,
        permission: [
          {
            action: 'view',
            entity: 'discovery_project'
          }
        ]
      }
    },
    {
      path: 'archives/tags/:tagname?',
      component: ProjectArchivedItemsListing,
      meta: {
        tabType: 0,
        permission: [
          {
            action: 'view',
            entity: 'discovery_project'
          }
        ]
      }
    },
    {
      path: 'archives/vault/tags/:tagname?',
      component: ProjectArchivedVaultItemListing,
      meta: {
        tabType: 1,
        permission: [
          {
            action: 'view',
            entity: 'discovery_project'
          }
        ]
      }
    }
  ],
  meta: {
    showProjectTab: true
  }
};
